module.exports = __webpack_public_path__ + "30759b7aada6d9489543086f1e388fbe.svg";